import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject, distinctUntilChanged, Observable, Subject } from 'rxjs';
import { Role } from 'src/app/Authentication/models/roles-permissions.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private router = inject(Router);

  public searchData = new Subject<any>()
  public sellObj = new Subject<any>()
  public productObj = new Subject<any>()
  public ROIObj = new Subject<any>()
  public homeObj = new Subject<any>()
  public obj = new Subject<any>()
  public Allobj = new Subject<any>()
  searchResult: Subject<any> = new Subject<any>();
  private responseSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private paramsSubject = new BehaviorSubject<Record<string, any>>({});
  params$ = this.paramsSubject.asObservable().pipe(distinctUntilChanged());
  private formDetailsMap = new Map<number, any>();
  private callSearchSubject = new Subject<void>();
  callSearch$ = this.callSearchSubject.asObservable();
  sendResponse(response: any) {
    this.responseSubject.next(response);
  }

  // Observable to subscribe to for receiving the response
  response$ = this.responseSubject.asObservable();
  /*object to store the state of MainComponent
  while routing back to home/dashboard(back buttons) from any component,
  action and productCategory(for highlighting purpose) need to be passed as queryParams*/
  public mainComponentState = {
    //to store the last clicked action in <app-menu> or search for <app-main-header>
    //or <left-sidebar>
    action: "home",
    //to store the last clicked product category in <left-sidebar>
    productCategory: null,
    //to store the last viewed page in <app-product-left-sidebar>
    page: 1,
    //to store the last searched string in <app-main-header>
    searchString: '',
    // to store the last filtered in <app-product-left-sidebar>
    filterCategoryValue: {},
    //to store the last selected panel in <left-sidebar>
    // selectedPanel: null
    item: ''
  }
  public backToTopClicked = new Subject<void>()
  // switchAsVendor(vendor: any) {
  //  let supplier:any={
  //     supplierId:vendor.vendor,
  //     supplierSiteCatalog:vendor.siteCatalog,
  //     supplierIsApproved:vendor.isVendorApproved,
  //     supplierSystemUser:vendor.systemUser
  //  }
  //   localStorage.setItem("supplier", JSON.stringify(supplier));
  //   this.supplier.next(localStorage.getItem("supplier"));
  //   this.router.navigate(["/vendor/dashboard"]);
  // }
  // removeVendorKeyFromLocalStorage(): void {
  //   let user:any = localStorage.getItem("currentUser");
  //   user = JSON.parse(user);
  //   console.log(user)
  //   user.roleType[0] = Role.SiteAdministrator;
  //   const updatedUser = JSON.stringify(user);
  //   localStorage.setItem("currentUser", updatedUser);
  //   this.router.navigate(['/admin/dashboard']);
  //   localStorage.removeItem('supplier');
  //   this.supplier.next(localStorage.getItem("supplier"));
  // }
  // Update parameters and ensure no duplicate emissions
  updateParams(params: Record<string, any>): void {
    const currentParams = this.paramsSubject.value;
    if (JSON.stringify(currentParams) !== JSON.stringify(params)) {
      this.paramsSubject.next(params);
    }
  }
  saveFormDetails(panelNumber: number, formDetails: any): void {
    this.formDetailsMap.set(panelNumber, formDetails);
  }

  getFormDetails(panelNumber: number): any {
    return this.formDetailsMap.get(panelNumber) || null;
  }

  clearFormDetails(panelNumber: number): void {
    this.formDetailsMap.delete(panelNumber);
  }
  clearAllFormDetails(): void {
    this.formDetailsMap.clear();
  }
  // search is called when search string is same
  apiCallSearch() {
    this.callSearchSubject.next();
  }
}

